import { useEffect, useState } from 'react'
import { RenderClient } from 'src/components/RenderClient'

import type { FlyComponent } from './flyer-props'
import './Flyer.scss'

function FlyerComponent(flypageProps: FlyComponent) {
  const { marginTop } = flypageProps
  const { marginBottom } = flypageProps
  const [isViewerInitialized, setViewerInitialized] = useState(false)

  useEffect(() => {
    const initializeSmartViewer = () => {
      const container = document.getElementById('flyercomponent')

      if (container && typeof window.SFviewer === 'function') {
        window.SFviewer({
          country: flypageProps.country,
          id: flypageProps.idcomponent,
          container_id: 'flyercomponent',
          sf_retailer_id: flypageProps.sfRetailerId,
          sf_section: flypageProps.sfSection,
          sf_flyer_id: flypageProps.sfFlyerId,
          sf_store_id: flypageProps.sfStoreId,
          sf_flyer_page: flypageProps.sfFlyerPage,
          // add events
          sf_enable_datalayer_events: true,
        })
      }
    }

    const loadScript = () => {
      const script = document.createElement('script')

      script.src = flypageProps.linkscript
      script.onload = initializeSmartViewer
      document.head.appendChild(script)
      setViewerInitialized(true)
    }

    if (!isViewerInitialized) {
      loadScript()
    }
  }, [flypageProps, isViewerInitialized])

  return isViewerInitialized ? (
    <div
      style={{ marginTop: `${marginTop}`, marginBottom: `${marginBottom}` }}
      className="flyer-component"
      id="flyercomponent"
    />
  ) : null
}

function FlyerComponentWrapper(flypageProps: FlyComponent) {
  return (
    <RenderClient>
      <FlyerComponent {...flypageProps} />
    </RenderClient>
  )
}

export default FlyerComponentWrapper
